<template>
  <div data-v-14cdb1fe="" class="contents">
    <nav data-v-14cdb1fe="" class="nav_mobile_top">
      <div data-v-14cdb1fe="" class="nav_content">
        <div data-v-14cdb1fe="" class="nav_left nav_left1">
          <div data-v-14cdb1fe="" class="back" @click="$router.go(-1)">
            <img
              data-v-14cdb1fe=""
              src="../../assets/img/arrow_back.d5eef796-0de7d3ca.svg"
              alt=""
            />
          </div>
          <div data-v-14cdb1fe="" class="nav_name2">{{ product.name }}</div>
          <div data-v-14cdb1fe="" class="start">
            <img
              v-if="!collectok"
              data-v-14cdb1fe=""
              src="../../assets/img/icon_start.5d0498aa-75525aba.svg"
              @click="gcollectgoods"
            /><img
              v-else
              data-v-14cdb1fe=""
              src="../../assets/img/icon_start1.72b20f52-ce12f504.svg"
              @click="ccollectgoods"
            />
          </div>
        </div>
      </div>
    </nav>
    <div data-v-14cdb1fe="" class="empty-box"></div>
    <div data-v-14cdb1fe="" class="contents-box" style="padding: 0px 20px">
      <div data-v-14cdb1fe="" class="containers">
        <div data-v-14cdb1fe="" class="content-title">
          <div data-v-14cdb1fe="" class="content-title-left">
            <div data-v-14cdb1fe="" class="left-number">
              {{ product.close }}
            </div>
            <div data-v-14cdb1fe="" class="left-icon">
              <div data-v-14cdb1fe="">
                {{ product.change }}<span data-v-14cdb1fe="">%</span>
              </div>
              <div data-v-14cdb1fe="" class="icons">
                <img
                  v-if="product.change > 0"
                  data-v-14cdb1fe=""
                  src="../../assets/img/up_arrow.05a4c908-32913ec4.svg"
                  alt=""
                />
                <img
                  v-else
                  :src="
                    require('../../assets/img/down_arrow.72e387a2-d4fc992a.svg')
                  "
                  alt=""
                  data-v-14cdb1fe=""
                />
              </div>
            </div>
          </div>
          <div data-v-14cdb1fe="" class="content-title-right">
            <div data-v-14cdb1fe="" class="right-info">
              <span data-v-14cdb1fe="">{{ $t('open') }}</span
              >{{ product.open }}
            </div>
            <div data-v-14cdb1fe="" class="right-info">
              <span data-v-14cdb1fe="">{{ $t('low') }}</span
              >{{ product.low }}
            </div>
            <div data-v-14cdb1fe="" class="right-info">
              <span data-v-14cdb1fe="">{{ $t('high') }}</span
              >{{ product.high }}
            </div>
            <div data-v-14cdb1fe="" class="right-info">
              <span data-v-14cdb1fe="">{{ $t('close') }}</span
              >{{ product.close }}
            </div>
          </div>
        </div>
        <div>
          <echarts :symbol="symbol" @updatedate="updatedate" />
        </div>

        <div data-v-14cdb1fe="" class="buttons" v-if="!showorder">
          <div data-v-14cdb1fe="" class="button" @click="opentrade(1)">
            {{ $t('up') }}
          </div>
          <div data-v-14cdb1fe="" class="button button1" @click="opentrade(2)">
            {{ $t('down') }}
          </div>
        </div>
        <div data-v-14cdb1fe="" class="model-mian" style="" v-if="showorder">
          <div
            data-v-14cdb1fe=""
            class="model-content"
            style=""
            v-if="tep == 1"
          >
            <div data-v-14cdb1fe="" class="model-content-title">
              <div data-v-14cdb1fe="" class="opmenus">
                <div
                  data-v-14cdb1fe=""
                  class="opmenu"
                  :class="selecttrade == 1 ? 'opmenu_active' : ''"
                  @click="selecttrade = 1"
                >
                  {{ $t('options') }}
                </div>
                <div
                  data-v-14cdb1fe=""
                  class="opmenu"
                  :class="selecttrade == 2 ? 'opmenu_active' : ''"
                  @click="selecttrade = 2"
                >
                  {{ $t('contract') }}
                </div>
              </div>
              <div data-v-14cdb1fe="" class="model-content-title-left">
                <div data-v-14cdb1fe="" class="left-number">
                  {{ product.name }}
                </div>
                <div data-v-14cdb1fe="" class="left-icon">
                  {{ product.close }}
                  <div data-v-14cdb1fe="" class="icons">
                    <img
                      v-if="product.change > 0"
                      data-v-14cdb1fe=""
                      src="../../assets/img/up_arrow.05a4c908-32913ec4.svg"
                    />
                    <img
                      v-else
                      src="../../assets/img/down_arrow.72e387a2-d4fc992a.svg"
                      data-v-14cdb1fe=""
                    />
                  </div>
                </div>
              </div>
              <div
                data-v-14cdb1fe=""
                class="model-colse"
                @click="showorder = false"
              >
                <img
                  data-v-14cdb1fe=""
                  src="../../assets/img/close.4248d375-b2c6030f.svg"
                  alt=""
                />
              </div>
            </div>
            <div data-v-14cdb1fe="" style="" v-if="selecttrade == 1">
              <div data-v-14cdb1fe="" class="model-content-times">
                <div
                  data-v-14cdb1fe=""
                  class="model-tiems"
                  :class="timeindex == index ? 'model_tiems_active' : ''"
                  v-for="(item, index) in optiondata"
                  @click="selecttime(index)"
                >
                  {{ item.c_times }} s
                  <div data-v-14cdb1fe="" class="model-time-info">
                    {{ $t('roi') }}:{{ item.c_odds }}%
                  </div>
                  <div data-v-14cdb1fe="" class="model-time-info">
                    {{ $t('limitye') }}≥{{ item.c_pay_min }}
                  </div>
                </div>
              </div>
              <div data-v-14cdb1fe="" class="input-list">
                <div data-v-14cdb1fe="" class="inputs inputs-max">
                  <div data-v-14cdb1fe="" class="lable">{{ $t('amount') }}</div>
                  <div data-v-14cdb1fe="" class="input-content">
                    <input
                      data-v-14cdb1fe=""
                      v-model="orderamount"
                      type="text"
                      class="input-style"
                      onchange="this.orderamount=this.orderamount.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                      onkeyup="this.orderamount=this.orderamount.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                      onafterpaste="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                      style="width: 100%"
                    />
                  </div>
                </div>
              </div>
              <div data-v-14cdb1fe="" class="content-info">
                <div data-v-14cdb1fe="" class="infos">
                  {{ $t('balance') }}
                  <div data-v-14cdb1fe="" class="info-number">
                    {{ userinfo.usdtbalance }}
                  </div>
                </div>
                <!---->
                <div data-v-14cdb1fe="" class="infos">
                  {{ $t('yuqishouyi') }}
                  <div data-v-14cdb1fe="" class="info-number">
                    +$
                    {{ (orderamount * optiondata[timeindex]['c_odds']) / 100 }}
                  </div>
                </div>
                <div data-v-14cdb1fe="" class="infos">
                  {{ $t('jiaoyifee') }}(Usd)
                  <div data-v-14cdb1fe="" class="info-number">
                    $
                    {{ (orderamount * tradesxf) / 100 }}
                  </div>
                </div>
              </div>
              <button
                data-v-14cdb1fe=""
                class="confirm-button"
                @click="beforsubmit"
              >
                {{ $t('confirm') }}
              </button>
            </div>
            <div data-v-14cdb1fe="" v-if="selecttrade == 2">
              <div
                data-v-7d9fa0f4=""
                data-v-c778fbe0=""
                class="contract-main"
                dir="auto"
              >
                <div data-v-7d9fa0f4="" class="pross">
                  <div data-v-7d9fa0f4="" class="pross-title">
                    {{ $t('gangan') }}:{{ parseFloat(levernum).toFixed(2) }}X
                  </div>
                  <van-slider
                    v-model="levernum"
                    bar-height="3px"
                    active-color="#c2e22a"
                    min="1"
                    max="200"
                    step="1"
                    button-size="12px"
                    class="leverage-progress"
                  />
                  <!---->
                  <div data-v-7d9fa0f4="" class="leverage-progress">
                    <div
                      data-v-7d9fa0f4=""
                      class="progress"
                      style="width: calc(100%); display: none"
                    ></div>
                    <div
                      data-v-7d9fa0f4=""
                      class="progress-circular progress-1x progress-circular-active"
                    ></div>
                    <div
                      data-v-7d9fa0f4=""
                      class="progress-circular progress-25x progress-circular-active"
                    ></div>
                    <div
                      data-v-7d9fa0f4=""
                      class="progress-circular progress-50x progress-circular-active"
                    ></div>
                    <div
                      data-v-7d9fa0f4=""
                      class="progress-circular progress-75x progress-circular-active"
                    ></div>
                    <div
                      data-v-7d9fa0f4=""
                      class="progress-circular progress-100x progress-circular-active"
                    ></div>
                  </div>
                  <div data-v-7d9fa0f4="" class="progress-identification">
                    <div data-v-7d9fa0f4="" class="identification-1x">1X</div>
                    <div data-v-7d9fa0f4="" class="identification-25x">50X</div>
                    <div data-v-7d9fa0f4="" class="identification-50x">
                      100X
                    </div>
                    <div data-v-7d9fa0f4="" class="identification-75x">
                      150X
                    </div>
                    <div data-v-7d9fa0f4="" class="identification-100x">
                      200X
                    </div>
                  </div>
                </div>
                <div data-v-7d9fa0f4="" class="entrust">
                  <div data-v-7d9fa0f4="">{{ $t('limitweit') }}</div>
                  <van-switch
                    v-model="xianjiachecked"
                    active-color="#c2e22a"
                    inactive-color="rgb(71, 71, 71)"
                  />
                </div>
                <div data-v-7d9fa0f4="" class="input-list">
                  <div data-v-7d9fa0f4="" class="inputs inputs-max">
                    <div data-v-7d9fa0f4="" class="lable">
                      {{ $t('buyprice') }}
                    </div>
                    <div data-v-7d9fa0f4="" class="input-content">
                      <input
                        data-v-7d9fa0f4=""
                        type="text"
                        v-model="cbuyprice"
                        onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                        onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                        class="inputs1"
                        :disabled="!xianjiachecked"
                      /><span data-v-7d9fa0f4="" class="option">{{
                        product.name
                      }}</span>
                    </div>
                  </div>
                </div>
                <div data-v-7d9fa0f4="" class="input-list">
                  <div data-v-7d9fa0f4="" class="inputs inputs-max">
                    <div data-v-7d9fa0f4="" class="lable">
                      {{ $t('buyhands') }}
                    </div>
                    <div data-v-7d9fa0f4="" class="input-content">
                      <input
                        data-v-7d9fa0f4=""
                        type="text"
                        onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                        onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                        class="inputs1"
                        v-model="cbhands"
                      />
                      <div data-v-7d9fa0f4="" class="inputs-bittons">
                        <div
                          data-v-7d9fa0f4=""
                          class="buttonss"
                          @click="changehands(1)"
                        >
                          -10
                        </div>
                        <div
                          data-v-7d9fa0f4=""
                          class="buttonss"
                          @click="changehands(2)"
                        >
                          +10
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-7d9fa0f4="" class="margins">
                  <div data-v-7d9fa0f4="">{{ $t('buybzjs') }}:${{ cbbzj }}</div>
                  <div data-v-7d9fa0f4="">{{ $t('buyfees') }}:${{ cbsxf }}</div>
                </div>
                <div data-v-7d9fa0f4="" class="entrust">
                  <div data-v-7d9fa0f4="">{{ $t('setzhys') }}</div>
                  <van-switch
                    v-model="zhiyzhis"
                    active-color="#c2e22a"
                    inactive-color="rgb(71, 71, 71)"
                    @change="changzhiys"
                  />
                </div>
                <div data-v-7d9fa0f4="" class="input-content" v-if="zhiyzhis">
                  <div data-v-7d9fa0f4="" class="input-lists">
                    <div data-v-7d9fa0f4="" class="input-list">
                      <div data-v-7d9fa0f4="" class="inputs inputs-max">
                        <div data-v-7d9fa0f4="" class="lable">
                          {{ $t('zhiying') }}
                        </div>
                        <div data-v-7d9fa0f4="" class="input-content">
                          <input
                            data-v-7d9fa0f4=""
                            type="text"
                            onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                            onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                            v-model="cbzhiying"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-7d9fa0f4="" class="input-lists">
                    <div data-v-7d9fa0f4="" class="input-list">
                      <div data-v-7d9fa0f4="" class="inputs inputs-max">
                        <div data-v-7d9fa0f4="" class="lable">
                          {{ $t('zhisun') }}
                        </div>
                        <div data-v-7d9fa0f4="" class="input-content">
                          <input
                            data-v-7d9fa0f4=""
                            type="text"
                            onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                            onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                            v-model="cbzhisun"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
                <div
                  data-v-7d9fa0f4=""
                  class="confirm-button"
                  @click="beforecontract"
                >
                  {{ $t('confirm') }}
                </div>
              </div>
            </div>
          </div>
          <div
            data-v-14cdb1fe=""
            class="model-content-buy model-content-content1 model-content-content2"
            v-if="tep == 2"
          >
            <div data-v-14cdb1fe="" class="model-content-title">
              <div data-v-14cdb1fe="" class="model-content-title-left">
                <div data-v-14cdb1fe="" class="left-number">
                  {{ product.name }}
                </div>
                <div data-v-14cdb1fe="" class="left-icon">
                  {{ product.close }}
                  <div data-v-14cdb1fe="" class="icons">
                    <img
                      v-if="product.change > 0"
                      data-v-14cdb1fe=""
                      src="../../assets/img/up_arrow.05a4c908-32913ec4.svg"
                    />
                    <img
                      v-else
                      src="../../assets/img/down_arrow.72e387a2-d4fc992a.svg"
                      data-v-14cdb1fe=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div data-v-14cdb1fe="" class="content-hr"></div>
            <div data-v-14cdb1fe="" class="content-box">
              <!----><span data-v-14cdb1fe="">
                <van-count-down
                  :time="buytimes * 1000"
                  format="ss"
                  @finish="finish"
                  style="color: #ffffff; font-size: 20px"
                  v-if="countdown"
                />
              </span>
              <div data-v-14cdb1fe="" class="time-info">
                {{ $t('roi') }}: {{ optiondata[timeindex]['c_odds'] }}%
              </div>
            </div>
            <div data-v-14cdb1fe="" class="content1-infos">
              <div data-v-14cdb1fe="" class="infos1">
                <div data-v-14cdb1fe="" class="info1">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('amountt') }}
                  </div>
                  <div data-v-14cdb1fe="" class="info1-content">
                    $ {{ orderamount }}
                  </div>
                </div>
                <div data-v-14cdb1fe="" class="info1" v-if="buydirection == 1">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('yuqishouyi') }}
                  </div>
                  <div
                    data-v-14cdb1fe=""
                    class="info1-content"
                    v-if="buyprice < product.close"
                  >
                    +$
                    {{ (orderamount * optiondata[timeindex]['c_odds']) / 100 }}
                  </div>
                  <div data-v-14cdb1fe="" class="info1-content" v-else>
                    -$
                    {{ (orderamount * optiondata[timeindex]['c_odds']) / 100 }}
                  </div>
                </div>
                <div data-v-14cdb1fe="" class="info1" v-if="buydirection == 2">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('yuqishouyi') }}
                  </div>
                  <div
                    data-v-14cdb1fe=""
                    class="info1-content"
                    v-if="buyprice > product.close"
                  >
                    +$
                    {{ (orderamount * optiondata[timeindex]['c_odds']) / 100 }}
                  </div>
                  <div data-v-14cdb1fe="" class="info1-content" v-else>
                    -$
                    {{ (orderamount * optiondata[timeindex]['c_odds']) / 100 }}
                  </div>
                </div>
              </div>
              <div data-v-14cdb1fe="" class="infos1">
                <div data-v-14cdb1fe="" class="info1">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('open') }}
                  </div>
                  <div data-v-14cdb1fe="" class="info1-content">
                    {{ buyprice }}
                  </div>
                </div>
                <div data-v-14cdb1fe="" class="info1">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('curentprice') }}
                  </div>
                  <div data-v-14cdb1fe="" class="info1-content">
                    {{ product.close }}
                  </div>
                </div>
              </div>
              <div data-v-14cdb1fe="" class="infos1 infos2">
                <div data-v-14cdb1fe="" class="info1">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('jiaofeee') }}(Usd)
                  </div>
                  <div data-v-14cdb1fe="" class="info1-content">
                    $ {{ buycost }}
                  </div>
                </div>
                <div data-v-14cdb1fe="" class="info1">
                  <div data-v-14cdb1fe="" class="info1-lable">
                    {{ $t('leixing') }}
                  </div>
                  <div
                    data-v-14cdb1fe=""
                    class="info1-content"
                    style="color: rgb(192, 221, 43)"
                    v-if="buydirection == 1"
                  >
                    {{ $t('up') }}
                  </div>
                  <div
                    data-v-14cdb1fe=""
                    class="info1-content"
                    style="color: #ce7735"
                    v-if="buydirection == 2"
                  >
                    {{ $t('down') }}
                  </div>
                  <!---->
                </div>
              </div>
            </div>
            <button
              data-v-14cdb1fe=""
              class="confirm-button"
              @click="closetrade"
            >
              {{ $t('jixuxiadan') }}
            </button>
          </div>
        </div>
      </div>
      <!--      <div data-v-14cdb1fe="" class="bottom-empty"></div>-->
    </div>
    <div data-v-14cdb1fe="" class="loadingbox" style="display: none"></div>
  </div>
</template>
<script>
import echarts from '@/components/echarts.vue'
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
function dateFormat(fmt, date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(),
    'd+': date.getDate().toString(),
    'H+': date.getHours().toString(),
    'M+': date.getMinutes().toString(),
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      )
    }
  }
  return fmt
}
export default {
  components: { echarts },
  data() {
    return {
      tradeData: {},
      selecttrade: 1,
      direction: 1,
      timeindex: 0,
      // 弹出层显示
      isshow: false,
      tradesxf: 0,
      countdown: true,
      // 弹窗的数据
      productlist: [],
      currycurrent: localStorage.getItem('currency') || 'USDT',
      // 自选
      ischecked: false,
      orderamount: 0,
      ordertype: 0,
      userinfo: {},
      buyprice: 0,
      buydirection: 1,
      buycost: 0,
      // 产品
      type: this.$route.params.id || 'btc',
      symbol: 'btcusdt',
      period: '15M',
      product: [],
      buytimes: 0,
      tep: 1,
      klinedata: {
        // date: [],
        // data: [],
        // vol: [],
      },
      // 产品详情
      detail: {},
      moneys: ['200', '2000', '5000', '10000'],
      // 当前价格
      currentprice: '',
      timer: null,
      showorder: false,
      optiondata: [],
      // 完成的订单列表
      completedorder: [],
      // 进行中的订单列表
      progressorder: [],
      // 买多买空弹出层
      tradeshow: false,
      tradeLoading: false,
      // 确认步骤
      tradestep: 1,
      feeradio: 1,
      // 选择标识
      isactive: null,
      isactives: null,
      // 买多买空数据对象
      tradedata: {
        type: 1, // 买多，买空
        price: 10, // 当前价格
        fee: 0, // 手续费
        balance: 0, // 可用余额
      },
      // 请求订单列表定时器
      tradetimer: '',
      lang: localStorage.getItem('lang') || 'zh',
      xianjiachecked: false,
      zhiyzhis: false,
      cbuyprice: 0,
      cbhands: 0,
      cbzhisun: 0,
      cbzhiying: 0,
      levernum: 200,
      collectok: false,
    }
  },

  computed: {
    cbbzj() {
      return (
        (parseFloat(this.cbuyprice) * this.cbhands) /
        this.levernum
      ).toFixed(2)
    },
    cbsxf() {
      return (
        (((parseFloat(this.cbuyprice) * this.cbhands) / this.levernum) *
          this.tradesxf) /
        100
      ).toFixed(2)
    },
  },

  created() {
    this.symbol = this.$route.query.symbol
      ? this.$route.query.symbol
      : 'btcusdt'
    this.getcollectok()
  },
  beforeDestroy() {
    clearInterval(this.tradetimer)
  },
  methods: {
    changzhiys(e) {
      if (e) {
        if (this.direction === 1) {
          this.cbzhiying = parseFloat(this.product.close) * 1.1
          this.cbzhisun = parseFloat(this.product.close) * 0.9
        } else {
          this.cbzhiying = parseFloat(this.product.close) * 0.9
          this.cbzhisun = parseFloat(this.product.close) * 1.1
        }
      }
    },
    changehands(t) {
      if (t === 1) {
        if (this.cbhands <= 10) {
          this.cbhands = 0
        } else {
          this.cbhands -= 10
        }
      } else {
        this.cbhands += 10
      }
    },
    updatedate(data) {
      this.product = data
      if (!this.xianjiachecked) {
        this.cbuyprice = data.close
      }
      console.log(this.product)
    },
    selecttime(i) {
      this.timeindex = i
    },
    closetrade() {
      this.tep = 1
    },

    opentrade(t) {
      this.showorder = true
      this.direction = t
      this.getdetail()
      this.getuserinfo()
    },

    // 获取产品详情
    async getdetail() {
      const { data } = await this.$http.post('/getoptiondata', {
        coinflag: this.symbol,
      })
      if (data) {
        if (data.code === 200) {
          this.optiondata = data.data.option
          this.tradesxf = data.data.tradesxf
        } else {
          this.$toast.error(this.$t('common.fail'))
        }
      }
    },
    // 获取产品详情
    async getcollectok() {
      const { data } = await this.$http.post('/determinecollect', {
        symbol: this.symbol,
      })
      if (data) {
        if (data.code === 200) {
          this.collectok = true
        }
      }
    },
    // 获取产品详情
    async gcollectgoods() {
      const { data } = await this.$http.post('/collectgoods', {
        symbol: this.symbol,
      })
      if (data) {
        if (data.code === 200) {
          this.collectok = true
        }
      }
    },
    // 获取产品详情
    async ccollectgoods() {
      const { data } = await this.$http.post('/canclecollectgoods', {
        symbol: this.symbol,
      })
      if (data) {
        if (data.code === 200) {
          this.collectok = false
        }
      }
    },
    // 获取产品详情
    async getuserinfo() {
      const { data } = await this.$http.post('/getuserinformation', {
        coinflag: this.symbol,
      })
      if (data) {
        if (data.code === '200') {
          this.userinfo = data.data.uinfo
        } else {
          this.$toast.error(this.$t('common.fail'))
        }
      }
    },

    // 去法币交易市场
    tofabi() {
      this.$router.push('/trade/Foreign')
    },
    // 去理财页面
    tofund() {
      this.$router.push('/fund')
    },
    // 添加或取消自选事件
    async changechecked() {
      const { data } = await this.$http.post('/determinecollect')
      if (data) {
        if (data.code === 200) {
          this.ischecked = true
        }
      }
    },

    beforecontract() {
      let zongpr = parseFloat(this.cbbzj) + parseFloat(this.cbsxf)
      console.log(zongpr)
      if (zongpr > parseFloat(this.userinfo.usdtbalance)) {
        this.$toast.fail('可用保证金不足')
        return false
      }
      this.submitcontract()
    },
    async submitcontract() {
      if (this.tradeLoading) {
        console.log('loading', this.tradeLoading)
        return false
      }
      this.tradeLoading = true
      const { data } = await this.$http.post('/createcontractorder', {
        direction: this.direction,
        fee: this.cbsxf,
        ggan: this.levernum,
        num: this.cbhands,
        price: this.cbuyprice,
        symbol: this.symbol,
        type: this.xianjiachecked ? 1 : 2,
        zsprice: this.cbzhisun,
        zyprice: this.cbzhiying,
        zyzsvalue: this.zhiyzhis,
      })
      if (data) {
        if (data.code === 200) {
          this.tradeLoading = false
          this.$toast.success(data.message)
        } else {
          this.$toast.fail(data.message)
        }
      }
    },
    // 验证订单
    beforsubmit() {
      if (!this.orderamount) {
        this.$toast.fail(this.$t('inputnum'))
        return false
      }
      let minnu = parseFloat(this.optiondata[this.timeindex]['c_pay_min'])
      let maxnu = parseFloat(this.optiondata[this.timeindex]['c_pay_max'])
      if (
        parseFloat(this.orderamount) < minnu ||
        parseFloat(this.orderamount) > maxnu
      ) {
        this.$toast.fail(this.$t('xiane'))
        return false
      }
      if (
        parseFloat(this.userinfo.usdtbalance) < parseFloat(this.orderamount)
      ) {
        this.$toast.fail(this.$t('banlancebz'))
        return false
      }
      this.submit()
    },
    // 倒计时结束
    finish() {
      // this.showorder = false
      this.countdown = false
    },
    // 提交订单
    async submit() {
      // this.tradeshow = false
      if (this.tradeLoading) {
        console.log('loading', this.tradeLoading)
        return false
      }
      this.tradeLoading = true
      const { data } = await this.$http.post('/createorder', {
        amount: this.orderamount,
        direction: this.direction,
        oid: this.optiondata[this.timeindex]['id'],
        symbol: this.symbol,
      })
      if (data) {
        if (data.code === 200) {
          // this.$toast.success(
          //   this.getlang(data.msg, localStorage.getItem('lang'))
          // )
          this.$toast.success(this.$t('success'))
          this.buytimes = data.data.times
          this.buyprice = data.data.buyprice
          this.buydirection = data.data.direction
          this.buycost = data.data.cost
          this.tep = 2
          this.countdown = true
          // this.tradeshow = false
          this.tradeLoading = false
        } else {
          this.$toast.fail(this.$t('fail'))
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  /deep/.van-tab {
    color: #ffffff;
    font-size: 0.9333rem;
  }
  /deep/.van-tab--active {
    color: #004ea3;
  }
}

/deep/ .van-tabs__nav {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background-color: #000;
  -webkit-user-select: none;
  user-select: none;
}

.maincontent {
  //padding: 44px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 0.93333rem;
  background: #000;
  // 产品
  .name-icon {
    width: 90%;
    margin: 0.93333rem 0 0.4rem 5%;
    color: #fff;
    font-size: 1.33333rem;
    text-align: left;
    display: flex;
    align-items: center;
  }
  // 价格
  .total {
    width: 100%;
    display: flex;
    justify-content: center;
    .head {
      width: 95%;
      padding: 0.8rem 1.2rem 0 1.2rem;
      color: #b4b4b4;
      border-radius: 0.53333rem;
      line-height: 1.6rem;
      display: flex;
      .head-now {
        flex: 0.5;
        line-height: 1.5rem;
        text-align: left;
        h1 {
          color: #85b480;
          font-size: 1.5rem;
        }
        span {
          font-size: 0.85333rem;
          margin-right: 0.26667rem;
        }
      }
      .head-history {
        display: flex;
        flex: 0.5;
        div {
          text-align: left;
          flex: 0.5;
        }
        .head-extreme span {
          font-size: 0.85333rem;
          color: #b2b2b2;
          margin-right: 0.26667rem;
        }
      }
    }
  }
  // k图
  .total .van-tabs {
    width: 95%;
    font-family: DIN-Medium, serif;
  }
  .total /deep/.van-tab--active {
    color: #004ea3;
  }
  // 订单列表
  .order-List {
    margin-bottom: 4rem;
    /deep/.van-tabs__wrap {
      //border-bottom: 0.02667rem solid #e5e5e5;
    }
    .currency-Increase {
      color: #000;
      padding: 0.8rem 1.33333rem 0.8rem 1.33333rem;
      font-size: 1.6rem;
      display: flex;
      align-items: center;
      line-height: 1.6rem;
      border-bottom: 0.02667rem solid #3b3b3b;
    }
    .currency-time {
      font-size: 0.8rem;
      color: grey;
      text-align: right;
    }
    // 简介
    .brief {
      padding: 1.06667rem;
      text-align: left;
      .brief-publish {
        padding-left: 0.53333rem;
        line-height: 2.93333rem;
        border-bottom: 0.02667rem solid #3b3b3b;
        h3 {
          color: #fff;
          font-size: 1rem;
        }
      }
      span {
        font-size: 0.93333rem;
        color: grey;
      }
    }
  }
  // 操作组
  .operation {
    width: 100%;
    height: 3.2rem;
    background-color: #000;
    position: fixed;
    bottom: 3.3rem;
    display: flex;
    align-items: center;
    //border-top: 0.02667rem solid #e5e5e5;
    z-index: 999;
    .van-button {
      width: 80%;
      height: 1.86667rem;
    }
  }
  // 弹出层
  .personage-head {
    height: 8%;
    background-color: #000 !important;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/.van-tab {
      color: grey;
      font-size: 0.9333rem;
    }
    /deep/.van-tab--active {
      color: #004ea3;
    }
    h3 {
      font-size: 1.3333rem;
    }
  }
  .popup-Increase {
    background-color: #f1f1f1;
    color: #000;
    padding: 0.8rem 1.33333rem 0.8rem 1.33333rem;
    border-bottom: 0.02667rem solid #fff;
    font-size: 0.93333rem;
  }
  // 交易弹出层
  .operation-buyUp {
    width: 85%;
    border-radius: 0.4rem;
    background-color: #000 !important;
    color: #fff !important;
    overflow: hidden;
    span {
      color: #fff;
    }
    h3 {
      padding-top: 4%;
      padding-bottom: 4%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 0.02667rem solid #fff;
      font-weight: 400;
      color: #ffffff;
      font-size: 1rem;
    }
    .text {
      height: 90%;
      .van-cell {
        font-size: 0.75333rem;
        height: 2rem;
        padding: 0.26667rem 0.8rem 0.26667rem 0.8rem;
        background-color: #000 !important;
      }
      .van-cell:after {
        border-bottom: 0;
      }
      .van-cell__title {
        text-align: left;
      }
      .currency-information {
        margin: 0.8rem 1.33333rem 1.33333rem 1.06667rem;
        line-height: 1.15rem;
        font-size: 0.93333rem;
        display: flex;
        white-space: nowrap;
        overflow-x: auto;
        .information {
          flex-grow: 1;
          flex-shrink: 0;
          margin-right: 0.2rem;
          width: 4rem;
          height: 4rem;
          background-color: #424c66;
          padding-top: 0.18rem;
          color: #094;
          border-top-left-radius: 0.26667rem;
          border-top-right-radius: 0.26667rem;
        }
        .bg {
          background-color: #004ea3;
          color: #fff;
        }
      }
      .money-information {
        margin: 0.8rem 1.33333rem 1.33333rem 1.06667rem;
        line-height: 1.5rem;
        font-size: 0.93333rem;
        display: flex;
        white-space: nowrap;
        overflow-x: auto;
        .moneynums {
          flex-grow: 1;
          flex-shrink: 0;
          margin-right: 0.2rem;
          width: 3rem;
          height: 1.5rem;
          background-color: #424c66;
          //padding-top: 0.18rem;
          color: #094;
          border-radius: 0.26667rem;
        }
        .bgs {
          background-color: #12ced4;
          color: #fff;
        }
      }
      /deep/.van-field__control {
        font-size: 1rem !important;
      }
      .count-down {
        margin-top: 0.53333rem;
        width: 8rem;
        height: 8rem;
        line-height: 8rem;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4rem;
        color: #d90012;
        font-size: 2rem;
        border: 0.1667rem solid #d90012;
      }
    }

    .qbye {
      width: 65%;
      margin-left: 10%;
    }
    .van-button {
      width: 100%;
      height: 10%;
      margin: 0;
      padding-top: 4%;
      padding-bottom: 4%;
      letter-spacing: 0.53333rem;
      color: #fff;
      background-color: #0123d3;
      border: none;
      border-top: 0.02667rem solid #fff;
      font-size: 1.06667rem;
      .van-button__text {
        color: #fff;
      }
    }
  }
}

.contract-main .pross .pross-title[data-v-7d9fa0f4] {
  font-style: normal;
  font-weight: 500;
  font-size: 1em;
  line-height: 1.1em;
  height: 1.1em;
  color: hsla(0, 0%, 100%, 0.3);
  text-align: left;
  margin-top: 1.2em;
}
.contract-main .pross .leverage-progress[data-v-7d9fa0f4] {
  width: 100%;
  height: 0.1em;
  background: #e7e7e7;
  margin-top: 1.2em;
  position: relative;
  touch-action: none;
}
.contract-main .entrust[data-v-7d9fa0f4] {
  width: 100%;
  height: 3.24em;
  display: flex;
  justify-content: space-between;
  font-style: normal;
  font-weight: 600;
  font-size: 1em;
  color: #fff;
  margin-top: 1.19em;
}
.input-list[data-v-7d9fa0f4] {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2em;
}
.contract-main .pross .leverage-progress[data-v-7d9fa0f4][data-v-533b8ec6] {
  width: 100%;
  height: 0.1em;
  background: #e7e7e7;
  margin-top: 1.2em;
  position: relative;
  touch-action: none;
}
.contract-main .pross .leverage-progress .progress[data-v-7d9fa0f4] {
  height: 0.2em;
  position: absolute;
  top: 0;
  background: #c0dd2b;
}
.contract-main .pross .leverage-progress .progress-1x[data-v-7d9fa0f4] {
  left: -0.1em;
}
.contract-main .pross .leverage-progress .progress-circular[data-v-7d9fa0f4] {
  width: 0.8em;
  height: 0.8em;
  background: #e7e7e7;
  position: absolute;
  top: -0.3em;
  border-radius: 0.8em;
  touch-action: none;
}
.van-slider {
  position: relative;
  width: 100%;
  height: 2px;
  background-color: #ebedf0;
  border-radius: 999px;
  cursor: pointer;
  top: 20px;
  z-index: 99;
}
.contract-main
  .pross
  .leverage-progress
  .progress-1x[data-v-7d9fa0f4][data-v-533b8ec6] {
  left: -6px;
}
.contract-main
  .pross
  .leverage-progress
  .progress[data-v-7d9fa0f4][data-v-533b8ec6] {
  height: 0.2em;
  position: absolute;
  top: 0;
  background: #c0dd2b;
}
.input-list[data-v-7d9fa0f4][data-v-533b8ec6] {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2em;
}
.input-list .inputs-max[data-v-7d9fa0f4] {
  width: 100%;
}
.input-list .inputs .lable[data-v-7d9fa0f4] {
  font-weight: 500;
  font-size: 1em;
  color: hsla(0, 0%, 100%, 0.3);
}
.input-list .inputs-max .input-content[data-v-7d9fa0f4] {
  padding: 0 0.06em 0 0.24em;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}
.input-list .inputs .input-content[data-v-7d9fa0f4][data-v-533b8ec6] {
  background: #d8d8d814;
  mix-blend-mode: normal;
  border-radius: 0.8em;
  margin-top: 0.08em;
  height: 2.5em;
  width: 100%;
  line-height: 2.5em;
  padding: 0 0.16em 0 1.2em;
  display: flex;
  justify-content: space-between;
  color: #fff;
  align-items: center;
  font-weight: 600;
  font-size: 1.14em;
}
.input-list .inputs-max .input-content .inputs1[data-v-7d9fa0f4] {
  width: calc(100% - 1.2em);
  height: 100%;
}
.input-list
  .inputs-max
  .input-content
  .option[data-v-7d9fa0f4][data-v-533b8ec6] {
  font-weight: 600;
  font-size: 1em;
  color: #c0dd2b;
  position: absolute;
  right: 0.64em;
  height: 100%;
}
.contract-main .pross .progress-identification[data-v-7d9fa0f4] {
  width: 100%;
  height: 0.16em;
  margin-top: 1.14em;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 1em;
  line-height: 100%;
  color: hsla(0, 0%, 100%, 0.3);
  position: relative;
}
.input-list .inputs-max .input-content .inputs-bittons[data-v-7d9fa0f4] {
  position: absolute;
  right: 0.06em;
  width: 8.2em;
}
.input-list
  .inputs-max
  .input-content
  .inputs-bittons
  .buttonss[data-v-7d9fa0f4] {
  width: 3.54em;
  height: 2em;
  background: #1a1a1a;
  border-radius: 1em;
  margin-left: 0.3em;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contract-main .input-content[data-v-7d9fa0f4],
.contract-main .margins[data-v-7d9fa0f4] {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.contract-main .margins[data-v-7d9fa0f4] {
  font-style: normal;
  font-weight: 500;
  font-size: 1em;
  color: hsla(0, 0%, 100%, 0.3);
  margin-top: 0.08em;
}
.input-content input[data-v-7d9fa0f4] {
  width: 100%;
  height: 100%;
}
.contract-main .pross .leverage-progress .progress-100x[data-v-7d9fa0f4] {
  left: 98%;
}
.confirm-button[data-v-7d9fa0f4] {
  font-weight: 600;
  font-size: 1.16em;
  color: #000;
  width: 100%;
  height: 2.48em;
  background: #c0dd2b;
  margin: auto;
  border-radius: 1.13em;
  text-align: center;
  line-height: 2.48em;
  margin-top: 1.24em;
}
.contract-main .pross .leverage-progress .c[data-v-7d9fa0f4] {
  background: #c0dd2b;
}
</style>
